import { render, staticRenderFns } from "./addShopInpt.vue?vue&type=template&id=4599c2dc&scoped=true"
import script from "./addShopInpt.vue?vue&type=script&lang=js"
export * from "./addShopInpt.vue?vue&type=script&lang=js"
import style0 from "./addShopInpt.vue?vue&type=style&index=0&id=4599c2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599c2dc",
  null
  
)

export default component.exports